import React from 'react';

const CommunicationChart = ({ data, onChartClick }) => {
  if (!data || !data.top_senders) {
    return (
      <div className="text-center py-8">
        <i className="bi bi-graph-up text-4xl text-blue-500 mb-3 block"></i>
        <p className="text-slate-600">Aucune donnée de communication disponible</p>
      </div>
    );
  }

  const { top_senders, frequency_analysis, total_emails } = data;

  // Prendre les 5 premiers expéditeurs pour le graphique
  const topSenders = top_senders.slice(0, 5);
  const maxCount = Math.max(...topSenders.map(sender => sender.count), 1);

  return (
    <div className="space-y-6" onClick={() => onChartClick && onChartClick('communication')}>
      {/* Graphique barres pour les expéditeurs */}
      <div>
        <h6 className="font-semibold mb-4 text-slate-700">Top expéditeurs</h6>
        <div className="space-y-3">
          {topSenders.map((sender, index) => {
            const percentage = (sender.count / maxCount) * 100;
            return (
              <div key={index} className="flex items-center space-x-3">
                <div className="text-sm text-slate-600 w-32 truncate" title={sender.sender}>
                  {sender.sender}
                </div>
                <div className="flex-1">
                  <div className="bg-blue-100 rounded-full h-4">
                    <div 
                      className="bg-blue-600 h-4 rounded-full transition-all duration-300"
                      style={{ width: `${percentage}%` }}
                    ></div>
                  </div>
                </div>
                <div className="text-sm font-semibold text-slate-800 w-12 text-right">
                  {sender.count}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Métriques de fréquence */}
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-blue-50 rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-blue-600">
            {frequency_analysis?.daily_average?.toFixed(1) || 0}
          </div>
          <div className="text-xs text-blue-700">Moyenne quotidienne</div>
        </div>
        <div className="bg-green-50 rounded-lg p-4 text-center">
          <div className="text-2xl font-bold text-green-600">
            {total_emails || 0}
          </div>
          <div className="text-xs text-green-700">Total emails</div>
        </div>
      </div>

      {/* Analyse des pics d'activité */}
      {frequency_analysis?.peak_days && frequency_analysis.peak_days.length > 0 && (
        <div>
          <h6 className="font-semibold mb-3 text-slate-700">Jours d'activité maximale</h6>
          <div className="space-y-2">
            {frequency_analysis.peak_days.slice(0, 3).map((day, index) => (
              <div key={index} className="flex justify-between items-center text-sm">
                <span className="text-slate-600">
                  {new Date(day.date).toLocaleDateString('fr-FR', { 
                    weekday: 'short', 
                    day: 'numeric', 
                    month: 'short' 
                  })}
                </span>
                <span className="font-semibold text-slate-800">{day.count} emails</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Résumé de la période */}
      {data.time_period && data.time_period.start && (
        <div className="text-center text-sm text-slate-500 border-t pt-3">
          Période analysée: {Math.ceil((new Date(data.time_period.end) - new Date(data.time_period.start)) / (1000 * 60 * 60 * 24))} jours
        </div>
      )}
    </div>
  );
};

export default CommunicationChart;